// extracted by mini-css-extract-plugin
export default {"external":"aCOqwv","tooltipTarget":"bCOqwv","inlineWrapper":"cCOqwv","inline":"dCOqwv","modalClassName":"eCOqwv","autoWidth":"fCOqwv"};